import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import SchedulingNewComponent from "../../components/SchedulingNewComponent";

const subRoutes = [
  {
    title: "#01 - Tipo de agendamento",
  },
  {
    title: "#02 - Dados do agendamento",
  },
  {
    title: "#03 - Agenda disponível",
  },
  {
    title: "#04 - Confirmação de agendamento",
  },
];

const SchedulingNew = ({
  branches,
  products,
  plants,
  loadProducts,
  loadBranches,
  loadPlants,
  clearBranches,
  loadTypes,
  types,
  addNewSchedule,
  scheduling,
  dates,
  loadDates,
  blocks,
  loadTurns,
  clearTurns,
  confirmed,
  setConfirmed,
  holdConfigs,
  loseConfigsWhenExit,
  confirmLeave,
  getDriver,
  selectedDriver,
  clients,
  loadClients,
  transporters,
  loadTransporters,
  getClientByDocument,
  loadPlantByDocumentNumber,
  loadBranchByPlant,
  loadProductsByPlant,
}) => {
  const [currentTab, setCurrentTab] = useState(0);

  const [editingItem, setEditingItem] = useState({});
  const [isLoadingTurn, setLoadingTurn] = useState(false);
  const [clearedTurn, setClearedTurn] = useState(true);

  const setTab = (tab) => {
    setCurrentTab(tab);
  };

  useEffect(() => {

    clearTurns([]);
    setClearedTurn(true)
  }, [currentTab, clearTurns]);

  useEffect(() => {
    loadTypes();
  }, [loadTypes]);

  useEffect(() => {
    loadClients();
  }, [loadClients]);

  useEffect(() => {
    loadTransporters();
  }, [loadTransporters]);

  useEffect(() => {
    editingItem.loadingType &&
      loadProducts({
        onlyAvailable: true,
        idLoadType: editingItem.loadingType,
      });
  }, [loadProducts, editingItem.loadingType]);

  useEffect(() => {
    editingItem.product &&
      loadBranches({
        productId: editingItem.product,
        loadTypeId: editingItem.loadingType,
      });
  }, [
    editingItem.product,
    editingItem.loadingType,
    loadBranches,
    editingItem.branch,
  ]);

  useEffect(() => {
    editingItem.product &&
      editingItem.branch &&
      loadPlants({
        idProduct: editingItem.product,
        idBranch: editingItem.branch,
        idLoadType: editingItem.loadingType,
      });
  }, [
    loadPlants,
    editingItem.product,
    editingItem.branch,
    editingItem.loadingType,
    editingItem.plant,
  ]);

  useEffect(() => {
    editingItem.cliente &&
      editingItem.loadingType &&
      editingItem.product &&
      editingItem.plant &&
      loadDates({
        idLoadType: editingItem.loadingType,
        idProduct: editingItem.product,
        idPlant: editingItem.plant,
        clientDocumentNumber: editingItem.cliente,
        transporterCNPJ: editingItem.transporterDocumentNumber,
      });
  }, [
    loadDates,
    editingItem.loadingType,
    editingItem.product,
    editingItem.plant,
    editingItem.cliente,
    editingItem.transporterDocumentNumber
  ]);

  useEffect(() => {
    const prepareTurn = async () => {
      if (editingItem.loadingType &&
        editingItem.product &&
        editingItem.plant &&
        editingItem.date) {
          setLoadingTurn(true);
          await loadTurns({
            idLoadType: editingItem.loadingType,
            idProduct: editingItem.product,
            idPlant: editingItem.plant,
            date: editingItem.date,
            clientDocumentNumber: editingItem.cliente,
            transporterCNPJ: editingItem.transporterDocumentNumber,
          });
          setLoadingTurn(false);
        }
    }
    prepareTurn().catch((err) => {
      setLoadingTurn(false);
    });
  }, [
    loadTurns,
    editingItem.loadingType,
    editingItem.product,
    editingItem.plant,
    editingItem.date,
    editingItem.cliente,
    editingItem.transporterDocumentNumber,
  ]);

  return (
    <SchedulingNewComponent
      setTab={setTab}
      currentTab={currentTab}
      subRoutes={subRoutes}
      editingItem={editingItem}
      setEditingItem={setEditingItem}
      products={products}
      branches={branches}
      loadTypes={types}
      plants={plants}
      addNewSchedule={addNewSchedule}
      scheduling={scheduling}
      dates={dates}
      turns={blocks}
      confirmed={confirmed}
      setConfirmed={setConfirmed}
      holdConfigs={holdConfigs}
      loseConfigsWhenExit={loseConfigsWhenExit}
      confirmLeave={confirmLeave}
      getDriver={getDriver}
      selectedDriver={selectedDriver}
      clients={clients}
      transporters={transporters}
      getClientByDocument={getClientByDocument}
      loadPlantByDocumentNumber={loadPlantByDocumentNumber}
      loadBranchByPlant={loadBranchByPlant}
      loadProductsByPlant={loadProductsByPlant}
      loadPlants={loadPlants}
      isLoadingTurn={isLoadingTurn}
      clearedTurn={clearedTurn}
      setClearedTurn={setClearedTurn}
    />
  );
};

const mapStateToProps = ({
  cargillBranches: { branches },
  products: { products },
  plants: { plants },
  dates: { dates },
  loadTypes: { types },
  timeBlocks: { blocks },
  driver,
  newScheduling,
  clients: { clients },
  transporters: { transporters },
}) => ({
  branches: branches.map((branch) => ({
    value: branch.id,
    label: branch.name,
  })),
  products: products.map((product) => ({
    value: product.id,
    label: product.name,
  })),
  plants: plants.map((plant) => ({
    value: plant.id,
    label: plant.name,
  })),
  dates,
  types,
  blocks,
  confirmed: newScheduling.confirmed,
  scheduling: newScheduling.scheduling,
  loseConfigsWhenExit: newScheduling.loseConfigsWhenExit,
  selectedDriver: driver.selectedDriver,
  clients: clients.map((client) => ({
    value: client.document_number,
    label: `${client.document_number} - ${client.name}`,
    name: client.name,
  })),
  transporters: transporters.map((transporter) => ({
    value: transporter.document_number,
    label: `${transporter.document_number} - ${transporter.name}`,
    name: transporter.name,
  })),
});

const mapDispatch = (dispatch) => ({
  loadTypes: () => dispatch.loadTypes.loadAsync(),
  loadProducts: (payload) => dispatch.products.loadAsync(payload),
  loadBranches: (payload) =>
    dispatch.cargillBranches.loadAvailableByProductIdAsync(payload),
  loadPlants: (payload) => dispatch.plants.loadAvailableAsync(payload),
  clearBranches: (payload) => dispatch.branches.clearStore(payload),
  addNewSchedule: (payload) => dispatch.newScheduling.addAsync(payload),
  loadDates: (payload) => dispatch.dates.loadAvailableDatesAsync(payload),
  loadTurns: (payload) => dispatch.timeBlocks.loadAvailableByDateAsync(payload),
  clearTurns: (payload) => dispatch.timeBlocks.clearTurns(payload),
  setConfirmed: (payload) => dispatch.newScheduling.setConfirmed(payload),
  holdConfigs: (payload) =>
    dispatch.newScheduling.loseConfigsWhenExitAsync(payload),
  confirmLeave: (payload) => dispatch.dialog.confirmLeave(payload),
  getDriver: (payload) => dispatch.driver.getDriverByCNHAsync(payload),
  loadClients: (payload) => dispatch.clients.loadClientsAsync(payload),
  loadTransporters: (payload) =>
    dispatch.transporters.loadTransportersAsync(payload),
  getClientByDocument: (payload) =>
    dispatch.scheduling.getClientByDocumentAsync(payload),
  loadPlantByDocumentNumber: (payload) =>
    dispatch.plants.findByDocumentNumberAsync(payload),
  loadBranchByPlant: (payload) =>
    dispatch.cargillBranches.loadAvailableByPlantIdAsync(payload),
  loadProductsByPlant: (payload) => dispatch.products.loadByPlantAsync(payload),
});

SchedulingNew.propTypes = {
  branches: PropTypes.array.isRequired,
  scheduling: PropTypes.object,
  products: PropTypes.array.isRequired,
  plants: PropTypes.array.isRequired,
  loadBranches: PropTypes.func.isRequired,
  loadProducts: PropTypes.func.isRequired,
  loadPlants: PropTypes.func.isRequired,
  dates: PropTypes.array.isRequired,
  loadDates: PropTypes.func.isRequired,
  turns: PropTypes.array,
  loadTurns: PropTypes.func.isRequired,
  clearTurns: PropTypes.func.isRequired,
  clients: PropTypes.array.isRequired,
  loadClients: PropTypes.func.isRequired,
  transporters: PropTypes.array.isRequired,
  loadTransporters: PropTypes.func.isRequired,
  getClientByDocument: PropTypes.func.isRequired,
  loadPlantByDocumentNumber: PropTypes.func.isRequired,
  loadBranchByPlant: PropTypes.func.isRequired,
  loadProductsByPlant: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatch)(SchedulingNew);
